/* Lightweight, on-device Promotions personalisation (no app, no tracking off
   the device). Each product/collection page sets window.JY_PAGE_DEPT; we keep a
   small interest tally in localStorage and, on pages with a Promotions rail,
   float the products from the shopper's most-viewed departments to the front —
   without hiding anything or breaking the best-selling order within a group. */
(function () {
  var KEY = 'jy_interests';
  var MAX = 40; /* cap so recent interest dominates over all-time */

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '{}');
      return v && typeof v === 'object' ? v : {};
    } catch (e) {
      return {};
    }
  }
  function write(v) {
    try {
      localStorage.setItem(KEY, JSON.stringify(v));
    } catch (e) {}
  }

  /* 1) record this page's department */
  var dept = window.JY_PAGE_DEPT;
  if (dept) {
    var t = read();
    t[dept] = (t[dept] || 0) + 1;
    /* soft decay of the others so interest stays current */
    Object.keys(t).forEach(function (k) {
      if (k !== dept && t[k] > 0) t[k] = t[k] * 0.94;
      if (t[k] < 0.15) delete t[k];
    });
    if (t[dept] > MAX) {
      Object.keys(t).forEach(function (k) {
        t[k] = (t[k] / t[dept]) * MAX;
      });
    }
    write(t);
  }

  /* 2) personalise any Promotions rail on this page */
  function ranked() {
    var t = read();
    return Object.keys(t)
      .filter(function (k) {
        return t[k] >= 2;
      }) /* need a real signal, not one stray view */
      .sort(function (a, b) {
        return t[b] - t[a];
      });
  }

  /* auto-select the "Pour vous" best-seller tab matching the top interest */
  function personaliseTabs(order) {
    document.querySelectorAll('[data-jy-grid-tabs]').forEach(function (tabs) {
      var section = tabs.closest('.shopify-section') || tabs.parentElement;
      if (!section) return;
      var match = null;
      for (var i = 0; i < order.length && !match; i++) {
        match = tabs.querySelector('[data-jy-tab][data-jy-dept="' + order[i] + '"]');
      }
      if (!match || match.classList.contains('jy-chip--active')) return;
      var idx = match.getAttribute('data-jy-tab');
      tabs.querySelectorAll('[data-jy-tab]').forEach(function (t) {
        var on = t === match;
        t.classList.toggle('jy-chip--active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      section.querySelectorAll('[data-jy-tab-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-jy-tab-panel') !== idx;
      });
    });
  }

  function personalise() {
    var order = ranked();
    if (!order.length) return; /* new/unknown shopper → leave best-selling order */
    personaliseTabs(order);
    document.querySelectorAll('[data-jy-personalize-rail]').forEach(function (rail) {
      var cards = Array.prototype.slice.call(rail.children);
      if (cards.length < 3) return;
      /* stable sort: matching departments first (by interest rank), the rest
         keep their original best-selling order */
      var withIdx = cards.map(function (el, i) {
        var d = el.getAttribute('data-jy-dept') || '';
        var r = order.indexOf(d);
        return { el: el, i: i, rank: r === -1 ? 999 : r };
      });
      withIdx.sort(function (a, b) {
        return a.rank - b.rank || a.i - b.i;
      });
      /* only touch the DOM if the order actually changed */
      var changed = withIdx.some(function (o, i) {
        return o.el !== cards[i];
      });
      if (!changed) return;
      var frag = document.createDocumentFragment();
      withIdx.forEach(function (o) {
        frag.appendChild(o.el);
      });
      rail.appendChild(frag);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', personalise);
  } else {
    personalise();
  }
})();
